import { cn } from "@theprelude/core";
import { ChevronIcon, Truncate } from "@theprelude/ds";
import { ReactNode } from "react";

interface Breadcrumb {
  label: string;
  icon: ReactNode;
}

export const Breadcrumbs = ({
  path,
  className,
}: {
  path: Breadcrumb[];
  className?: string;
}) => (
  <Truncate text={path.map((p) => p.label).join(" › ")}>
    <div className={cn("flex items-center gap-1", className)}>
      {path.map((breadcrumb, i) => (
        <div key={i} className="flex items-center gap-1 whitespace-nowrap">
          <span className="text-secondary-foreground">{breadcrumb.icon}</span>
          <span>{breadcrumb.label}</span>
          {i < path.length - 1 && (
            <ChevronIcon className="rotate-90 text-secondary-foreground" />
          )}
        </div>
      ))}
    </div>
  </Truncate>
);
